/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
export function isRequiredValidation(validations?: { type: string }[]) {
  return validations?.some(({ type }) => type === 'required');
}
